export default __webpack_public_path__ + "assets/images/c_acc.1bfb6d8.jpg";